export default __webpack_public_path__ + "fonts/4f756293f57a7db5fd7512a12673904e.svg";